import { Navigate, Outlet } from "react-router-dom";
import { getDecodedToken, clearAuthTokens } from "utils/tokenUtils";

export const AuthRoute = () => {
  const decoded = getDecodedToken();

  if (!decoded) {
    return <Outlet />;
  }

  // Token is valid, check for empty fields
  let emptyFields = false;
  if (
    decoded?.name === "" ||
    decoded?.email === "" ||
    decoded?.designation === ""
  ) {
    emptyFields = true;
  }

  return emptyFields ? (
    <Navigate to="/profile" replace />
  ) : (
    <Navigate to="/" replace />
  );
};
